import { render, staticRenderFns } from "./ModuleTopics.vue?vue&type=template&id=71fd728e&"
import script from "./ModuleTopics.vue?vue&type=script&lang=js&"
export * from "./ModuleTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports